import { LocalizedText } from '@mews/framework';
import { Link, TextStyle, Typography, TypographyVariant } from '@optimus-web/core';
import { BusinessComponentsTextKey as TextKey } from '../../utils/BusinessComponentsTextKey';

interface RecaptchaBrandingProps {
    align?: 'left' | 'right' | 'center';
    mewsPrivacyPolicyUrl: string | null;
    textStyle?: `${TextStyle}`;
    textVariant?: TypographyVariant;
}

export const RecaptchaBranding = ({
    align = 'center',
    mewsPrivacyPolicyUrl,
    textStyle = 'bodySmall',
    textVariant = 'secondary',
}: RecaptchaBrandingProps) => (
    <Typography textStyle={textStyle} variant={textVariant} align={align} as="div">
        <LocalizedText
            textKey={TextKey.GoogleRecaptchaBranding}
            substitutes={{
                privacyPolicy: (
                    <Link href={privacyPolicyUrl} inherit target="_blank" rel="noreferrer">
                        <LocalizedText textKey={TextKey.PrivacyPolicy} />
                    </Link>
                ),
                termsOfService: (
                    <Link href={termsOfServiceUrl} inherit target="_blank" rel="noreferrer">
                        <LocalizedText textKey={TextKey.TermsOfService} />
                    </Link>
                ),
                mewsPrivacyPolicy:
                    mewsPrivacyPolicyUrl != null ? (
                        <Link href={mewsPrivacyPolicyUrl} inherit target="_blank" rel="noreferrer">
                            <LocalizedText textKey={TextKey.MewsPrivacyNotice} />
                        </Link>
                    ) : (
                        <LocalizedText textKey={TextKey.MewsPrivacyNotice} />
                    ),
            }}
        />
    </Typography>
);

const privacyPolicyUrl = 'https://policies.google.com/privacy';
const termsOfServiceUrl = 'https://policies.google.com/terms';
